import { useContext } from "react";

import moment, { Moment } from "moment";
import {
    DateValidationError,
    PickerChangeHandlerContext
} from "@mui/x-date-pickers";

import TimeZoneContext from "context/timeZone/timeZoneContext";
import { YYYY_MM_DD, YYYY_MM_DD_HH_mm_ss } from "shared";

export const useDatePicker = () => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const hasDatePickerError = (
        context: PickerChangeHandlerContext<DateValidationError>
    ) => context.validationError !== null;

    const parseDatePickerValue = (
        value: Moment | null,
        context: PickerChangeHandlerContext<DateValidationError>,
        defaultValue: string | null,
        isInLocalTime?: boolean
    ) => {
        if (value !== null) {
            const hasError = hasDatePickerError(context);

            if (hasError) {
                return defaultValue;
            }

            return isInLocalTime
                ? getLocalDate(value).utc().format(YYYY_MM_DD_HH_mm_ss)
                : moment(value).format(YYYY_MM_DD);
        }

        return null;
    };

    const getLocalDate = (value: Moment) => moment.tz(value, currentTimeZone);

    return {
        hasDatePickerError,
        parseDatePickerValue,
        getLocalDate
    };
};
